import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import chartsRouter from './modules/charts'
import tableRouter from './modules/table'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * 没有权限要求的基页
 * 所有角色都可以访问
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  // {
  //   path: "/home",
  //   component: Layout,
  //   redirect: "/dashboard",
  //   children: [
  //     {
  //       path: "dashboard",
  //       component: () => import("@/views/dashboard/index"),
  //       name: "Dashboard",
  //       meta: { title: "首页", icon: "dashboard", affix: true },
  //     },
  //   ],
  // },
  // {
  //   path: '/documentation',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/documentation/index'),
  //       name: 'Documentation',
  //       meta: { title: 'Documentation', icon: 'documentation', affix: true }
  //     }
  //   ]
  // },

  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  // {
  //   path: "/icon",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/icons/index"),
  //       name: "Icons",
  //       meta: { title: "Icons", icon: "icon", noCache: true },
  //     },
  //   ],
  // },

  // 用户管理
  // {
  //   path: "/system_user_list",
  //   component: Layout,
  //   redirect: "noRedirect",
  //   meta: {
  //     title: "用户管理",
  //     icon: "el-icon-user-solid",
  //   },
  //   children: [
  //     {
  //       path: "system_user_list",
  //       name: "用户统计",
  //       meta: {
  //         title: "用户统计",
  //       },
  //       component: () => import("@/views/userstatic/system_user_list.vue"),
  //     },
  //     {
  //       path: "registered_sers",
  //       name: "注册用户",
  //       meta: {
  //         title: "注册用户",
  //       },
  //       component: () => import("@/views/userstatic/registered_sers.vue"),
  //     },
  //     {
  //       path: "valid_user",
  //       name: "有效用户",
  //       meta: {
  //         title: "有效用户",
  //       },
  //       component: () => import("@/views/userstatic/valid_user.vue"),
  //     },
  //     {
  //       path: "invalid_user",
  //       name: "无效用户",
  //       meta: {
  //         title: "无效用户",
  //       },
  //       component: () => import("@/views/userstatic/invalid_user.vue"),
  //     },

  //     {
  //       path: "system_user_ip",
  //       name: "IP检测",
  //       meta: {
  //         title: "IP检测",
  //       },
  //       component: () => import("@/views/userstatic/system_user_ip.vue"),
  //     },

  //   ],
  // },
  //  // 资金管理
  //  {
  //   path: "/system_data_list",
  //   redirect: "noRedirect",
  //   alwaysShow: true,
  //   component: Layout,
  //   meta: {
  //     title: "资金管理",
  //     icon: "el-icon-s-order",
  //   },
  //   children: [
  //     // 资金列表
  //     {
  //       path: "system_data_list",
  //       name: "资金列表",
  //       meta: {
  //         title: "资金列表",
  //       },
  //       component: () => import("@/views/systemDataList/system_data_list.vue"),
  //     },
  //      // 充值订单
  //      {
  //       path: "system_order",
  //       name: "充值订单",
  //       meta: {
  //         title: "充值订单",
  //       },
  //       component: () => import("@/views/systemDataList/system_order.vue"),
  //     },
  //       // 用户提现
  //       {
  //         path: "system_payment",
  //         name: "用户提现",
  //         meta: {
  //           title: "用户提现",
  //         },
  //         component: () => import("@/views/systemDataList/system_payment.vue"),
  //       },
  //   ],
  // },
  // // 产品管理
  // {
  //   path: "/system_product_list",
  //   component: Layout,
  //   redirect: "noRedirect",
  //   alwaysShow: true,
  //   meta: {
  //     title: "产品管理",
  //     icon: "el-icon-s-goods",
  //   },
  //   children: [
  //     // 代收订单
  //     {
  //       path: "system_product_list",
  //       name: "产品列表",
  //       meta: {
  //         title: "产品列表",
  //       },
  //       component: () =>
  //         import("@/views/productManagement/system_product_list.vue"),
  //     },
  //   ],
  // },
  //  // 前端管理
  //  {
  //   path: "/system_exchange",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "前端管理",
  //     icon: "el-icon-s-data",
  //   },
  //   children: [
  //     // 轮播图"
  //     {
  //       path: "rotation_chart",
  //       name: "轮播图",
  //       meta: {
  //         title: "轮播图",
  //       },
  //       component: () =>
  //         import("@/views/operationManagement/rotation_chart.vue"),
  //     },
  //     // 资讯"
  //     // {
  //     //   path: "system_Information",
  //     //   name: "资讯",
  //     //   meta: {
  //     //     title: "资讯",
  //     //   },
  //     //   component: () =>
  //     //     import("@/views/operationManagement/system_Information.vue"),
  //     // },
  //     // 公告
  //     {
  //       path: "system_announcement",
  //       name: "公告",
  //       meta: {
  //         title: "公告",
  //       },
  //       component: () =>
  //         import("@/views/operationManagement/system_announcement.vue"),
  //     },
  //     // 签到奖励
  //     {
  //       path: "system_check",
  //       name: "签到奖励",
  //       meta: {
  //         title: "签到奖励",
  //       },
  //       component: () => import("@/views/operationManagement/system_check.vue"),
  //     },
  //     {
  //       path: "system_config",
  //       name: "系统配置",
  //       meta: {
  //         title: "系统配置",
  //       },
  //       component: () => import("@/views/operationManagement/system_config.vue"),
  //     },
  //     {
  //       path: "system_serve_list",
  //       name: "客服列表",
  //       meta: {
  //         title: "客服列表",

  //       },
  //       component: () => import("@/views/staticsere/system_serve_list.vue"),
  //     },
  //   ],
  // },
  // // 客服管理
  // // {
  // //   path: "/system_serve_statics",
  // //   redirect: "noRedirect",
  // //   component: Layout,
  // //   meta: {
  // //     title: "客服管理",
  // //     icon: "el-icon-phone",
  // //   },
  // //   children: [
  // //     // 代收订单
  // //     {
  // //       path: "system_serve_statics",
  // //       name: "客服统计",
  // //       meta: {
  // //         title: "客服统计",
  // //       },
  // //       component: () => import("@/views/staticsere/system_serve_statics.vue"),
  // //     },
  // //     // 代付订单
  // //     {
  // //       path: "system_serve_list",
  // //       name: "客服列表",
  // //       meta: {
  // //         title: "客服列表",

  // //       },
  // //       component: () => import("@/views/staticsere/system_serve_list.vue"),
  // //     },
  // //   ],
  // // },
  // // 流水管理
  // {
  //   path: "/system_details",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "流水管理",
  //     icon: "el-icon-s-marketing",
  //   },
  //   children: [
  //     // 交易明细
  //     {
  //       path: "system_details",
  //       name: "交易明细",
  //       meta: {
  //         title: "交易明细",
  //       },
  //       component: () => import("@/views/systemDetails/system_details.vue"),
  //     },
  //     // 充值记录
  //     {
  //       path: "order_record",
  //       name: "充值记录",
  //       meta: {
  //         title: "充值记录",
  //       },
  //       component: () => import("@/views/systemDetails/order_record.vue"),
  //     },
  //     // 提现记录
  //     {
  //       path: "payment_record",
  //       name: "提现记录",
  //       meta: {
  //         title: "提现记录",
  //       },
  //       component: () => import("@/views/systemDetails/payment_record.vue"),
  //     },
  //   ],
  // },

  // // 系统管理
  // {
  //   path: "/system_admin",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "系统管理",
  //     icon: "el-icon-setting",
  //   },
  //   children: [
  //     // 管理员
  //     {
  //       path: "system_admin",
  //       name: "管理员管理",
  //       meta: {
  //         title: "管理员管理",
  //       },
  //       component: () => import("@/views/system_admin/system_admin.vue"),
  //     },
  //     // 角色
  //     {
  //       path: "system_roles",
  //       name: "角色管理",
  //       meta: {
  //         title: "角色管理",
  //       },
  //       component: () => import("@/views/system_admin/system_roles.vue"),
  //     },
  //     {
  //       path: "system_pay",
  //       name: "支付配置",
  //       meta: {
  //         title: "支付配置",
  //       },
  //       component: () => import("@/views/system_admin/system_pay.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: '*',
  //   redirect: '/404',

  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

// 控制路由滚动行为  滚动到顶部
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
